module.exports = __webpack_public_path__ + "img/happytablet_product3.e1ef69c0.jpg";